export default "__VITE_ASSET__rBPV_ET$__"